import { AnyAction } from 'redux'
import { UNLOCK_ORDER } from './unlockPage'

const initialUnlockToken: string = 'UNKNOWN'

const unlockTokenReducer = (
  currentUnlockToken: string = initialUnlockToken,
  action: AnyAction,
): string => {
  switch (action.type) {
    case UNLOCK_ORDER:
      return action.token
    default:
      return currentUnlockToken
  }
}

export default unlockTokenReducer
